export default __webpack_public_path__ + "static/media/404.04b1e13a.svg";